var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTickmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selection_box_1",
    "data-name": "Selection box 1",
    transform: "translate(0.252 0.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Selection_box",
    "data-name": "Selection box",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(-0.252 -0.486)",
    fill: "#1487ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tick",
    d: "M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,1,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z",
    transform: "translate(-5.657 -8.116)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickmark);
export default __webpack_public_path__ + "static/media/icon_tickmark.624db00c0b854463b853f7db42704f41.svg";
export { ForwardRef as ReactComponent };